import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import { RefreshDigitalSignatureStatusClientResponse } from '../@types/digitalSignature/RefreshDigitalSignatureStatus'

type Store = {
  isSigned: boolean
  isSignedResume: boolean
  isLoadingRefreshDigitalSignatureStatus: boolean
  refreshDigitalSignatureStatus: RefreshDigitalSignatureStatusClientResponse | null
  setIsSigned: (value: boolean) => void
  setIsSignedResume: (value: boolean) => void
  setRefreshDigitalSignatureStatus: (
    value: RefreshDigitalSignatureStatusClientResponse,
  ) => void
  setIsLoadingRefreshDigitalSignatureStatus: (value: boolean) => void
}

export const useRefreshDigitalSignatureStatusStore = create<Store>()(
  devtools(
    (set) => ({
      isSigned: false,
      isSignedResume: false,
      isLoadingRefreshDigitalSignatureStatus: false,
      refreshDigitalSignatureStatus: null,
      setIsSigned: (isSigned) => set({ isSigned }),
      setIsSignedResume: (isSignedResume) => set({ isSignedResume }),
      setIsLoadingRefreshDigitalSignatureStatus: (
        isLoadingRefreshDigitalSignatureStatus,
      ) => set({ isLoadingRefreshDigitalSignatureStatus }),
      setRefreshDigitalSignatureStatus: (refreshDigitalSignatureStatus) =>
        set({ refreshDigitalSignatureStatus }),
    }),
    { name: 'RefreshDigitalSignatureStatus' },
  ),
)
